import "plyr/dist/plyr.css";
import { createApp } from 'vue';
import { MotionPlugin } from '@vueuse/motion';
import App from './App.vue';
import router from './router';

// Icons
import 'boxicons/css/boxicons.min.css';

// ✅ Toastification (Vue 3 compatible version)
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css'; // Must be imported!

// Toast options
const toastOptions = {
  position: POSITION.BOTTOM_RIGHT,
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  icon: true,
};

const app = createApp(App);

// Register plugins
app.use(router);
app.use(MotionPlugin);
app.use(Toast, toastOptions);

// Mount app
app.mount('#app');


